
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gUry_45JrclHQryytlgcL0NumxGV0Tlb06Z_utwwZSovecMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexQFmOrsuIYnUpquw6DodbNg8IDvrwckk9K_CusxDi5msMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchqRQE39wgH1jgnTjYL5g6vuOS_45sYKapCn9Th6iBf4cDcMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexT2U63_45DvMCw82I8BG9wOnD5IZYKBk5zrluVvRc36utYMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93LMBee1eSkhheiuxTuPxB8DYW_H_45yC5Q41TLis6IoQJEMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexJWc1hJ__45_45IklJWr5H0_45dkLrn29R4f7v16Xjfgk_45uhr0Meta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93RXmRiBHyIYPARKsftgNGn1orkI6TRjDdOLB9Nm8gIdsMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index38cPvObgg_Jq2XnCQ_45bNCfxakNre163wDvNtYG4HvJsMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93hgSdIZX6KhlG17u2_45iwWwn4hxzn9EhhrJ_4519fcA3TJ0Meta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexCLvQmcpajn19CaV1xILObs1CL6pCuORyr4cnpngX0MQMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPq8iUsBGel5DUVgXnel7vtX5s40mido_Xt6izmPb4_45cMeta } from "/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexJWc1hJ__45_45IklJWr5H0_45dkLrn29R4f7v16Xjfgk_45uhr0Meta || {},
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index38cPvObgg_Jq2XnCQ_45bNCfxakNre163wDvNtYG4HvJsMeta || {},
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexCLvQmcpajn19CaV1xILObs1CL6pCuORyr4cnpngX0MQMeta || {},
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPq8iUsBGel5DUVgXnel7vtX5s40mido_Xt6izmPb4_45cMeta || {},
    component: () => import("/codebuild/output/src3543874269/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]